import { jsx as _jsx } from "react/jsx-runtime";
import { Pagination as MuiPagination, PaginationItem } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { ColorManipulator } from '../../themes';
import { Liquidity } from '../../design';
const useStyles = makeStyles(({ typography: { pxToRem } }) => ({
    selected: {},
    focusVisible: {},
    page: {
        fontSize: pxToRem(16),
        fontFamily: '"inter var", sans-serif',
        color: Liquidity.colors.text.standard,
        '&:hover, &$focusVisible': {
            backgroundColor: ColorManipulator.lighten(Liquidity.colors.primary.deepGreen, 0.95),
        },
        '&$selected': {
            backgroundColor: ColorManipulator.lighten(Liquidity.colors.primary.deepGreen, 0.85),
            color: Liquidity.colors.text.standard,
            fontWeight: 700,
            '&:hover, &$focusVisible': {
                backgroundColor: ColorManipulator.lighten(Liquidity.colors.primary.deepGreen, 0.75),
            },
        },
        '& .MuiPaginationItem-icon': {
            color: Liquidity.colors.text.standard,
        },
    },
}));
export function Pagination(props) {
    const classes = useStyles();
    return (_jsx(MuiPagination, Object.assign({ style: { display: 'flex' }, renderItem: (item) => (_jsx(PaginationItem, Object.assign({}, item, { className: classes.page, classes: { selected: classes.selected, focusVisible: classes.focusVisible } }), void 0)) }, props), void 0));
}
//# sourceMappingURL=Pagination.js.map